import { Key, ReactNode, createContext, useState } from "react";

interface AccordionGroupContextType {
  isOpen: (index: Key) => boolean;
  toggle: (index: Key) => void;
}

export const AccordionGroupContext = createContext<AccordionGroupContextType>({
  isOpen: () => false,
  toggle: () => {},
});

export interface AccordionGroupProps {
  children: ReactNode | ((values: AccordionGroupContextType) => ReactNode);
}

/**
 * Supports multiple Accordions
 */
export function AccordionGroup(props: AccordionGroupProps) {
  const [openKey, setOpenKey] = useState<Key | null>();

  const toggle = (key: Key) => {
    if (openKey === key) {
      setOpenKey(null);
    } else {
      setOpenKey(key);
    }
  };

  const isOpen = (key: Key) => openKey === key;

  return (
    <AccordionGroupContext.Provider value={{ isOpen, toggle }}>
      {typeof props.children === "function"
        ? props.children({ isOpen, toggle })
        : props.children}
    </AccordionGroupContext.Provider>
  );
}
